/**
 * ZaunIdeal — gemeinsame Shopify-Preis- & SKU-Hilfen für
 *   pages/konfigurator (configurator.js) und pages/doppelstab-konfigurator (doppelstab-konfigurator.js)
 *
 * API: window.ZaunIdealKonfigPricing
 */
(function (global) {
  'use strict';

  var skuIdCache = {};
  /** v2: cached row includes `sku` (needed for Doppelstab breakdown matching). */
  var variantDetailCache = {};
  var VARIANT_DETAIL_CACHE_PREFIX = 'v2:';

  function normalizeCartSku(s) {
    return String(s == null ? '' : s)
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '');
  }

  function normalizeVariantPriceToCents(p) {
    if (p == null || p === '') return null;
    var s = String(p).trim();
    var n = parseFloat(s.replace(',', '.'));
    if (isNaN(n)) return null;
    if (s.indexOf('.') !== -1 || s.indexOf(',') !== -1) return Math.round(n * 100);
    return Math.round(n);
  }

  function money(cents, format) {
    if (cents == null || isNaN(cents)) return '—';
    var withComma = (cents / 100).toFixed(2).replace('.', ',');
    var withDot = (cents / 100).toFixed(2);
    if (!format) return withComma + ' €';
    var out = format
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/gi, withComma)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/gi, String(Math.round(cents / 100)).replace(/\B(?=(\d{3})+(?!\d))/g, '.'))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/gi, String(Math.round(cents / 100)))
      .replace(/\{\{\s*amount\s*\}\}/gi, withDot);
    if (out.indexOf('{{') !== -1) return withComma + ' €';
    return out;
  }

  function primeSkuCache(handle, skuList, variantId) {
    if (!variantId || !handle || !skuList || !skuList.length) return;
    var c;
    for (c = 0; c < skuList.length; c++) {
      var n = normalizeCartSku(skuList[c]);
      if (n) skuIdCache[handle + ':' + n] = variantId;
    }
  }

  function fetchVariantIdBySku(handle, sku) {
    var norm = normalizeCartSku(sku);
    if (!handle || !norm) return Promise.resolve(null);
    var cacheKey = handle + ':' + norm;
    if (skuIdCache[cacheKey]) return Promise.resolve(skuIdCache[cacheKey]);
    return fetch('/products/' + encodeURIComponent(handle) + '.json')
      .then(function (r) {
        if (!r.ok || r.status === 404) return null;
        return r.text().then(function (text) {
          if (!text || !text.trim()) return null;
          try {
            return JSON.parse(text);
          } catch (e) {
            return null;
          }
        });
      })
      .then(function (data) {
        if (!data) return null;
        var variants = (data.product || {}).variants || [];
        var i;
        var v;
        var id;
        var keys;
        var k;
        var a;
        var b;
        for (i = 0; i < variants.length; i++) {
          v = variants[i];
          id = v.id;
          keys = [];
          a = normalizeCartSku(v.sku);
          b = normalizeCartSku(v.barcode);
          if (a) keys.push(a);
          if (b && b !== a) keys.push(b);
          for (k = 0; k < keys.length; k++) {
            skuIdCache[handle + ':' + keys[k]] = id;
          }
        }
        return skuIdCache[cacheKey] || null;
      })
      .catch(function () {
        return null;
      });
  }

  function fetchVariantDetailById(id) {
    var sid = String(id);
    var ck = VARIANT_DETAIL_CACHE_PREFIX + sid;
    if (variantDetailCache[ck]) return Promise.resolve(variantDetailCache[ck]);
    return fetch('/variants/' + encodeURIComponent(sid) + '.js')
      .then(function (r) {
        return r.text().then(function (text) {
          var body = (text || '').trim();
          if (!r.ok) throw new Error('variant');
          if (!body || body.charAt(0) === '<') throw new Error('variant');
          var v = JSON.parse(body);
          var pc = normalizeVariantPriceToCents(v.price);
          if (pc == null) throw new Error('variant');
          var cc = normalizeVariantPriceToCents(v.compare_at_price);
          var row = {
            id: v.id,
            price: pc,
            compare_at_price: cc != null ? cc : null,
            title: v.name,
            sku: v.sku != null ? String(v.sku) : '',
          };
          variantDetailCache[ck] = row;
          return row;
        });
      });
  }

  function clearCaches() {
    skuIdCache = {};
    variantDetailCache = {};
  }

  global.ZaunIdealKonfigPricing = {
    normalizeCartSku: normalizeCartSku,
    money: money,
    normalizeVariantPriceToCents: normalizeVariantPriceToCents,
    fetchVariantIdBySku: fetchVariantIdBySku,
    fetchVariantDetailById: fetchVariantDetailById,
    primeSkuCache: primeSkuCache,
    clearCaches: clearCaches,
  };
})(typeof window !== 'undefined' ? window : this);
